var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('CkEditor',{attrs:{"editor":_vm.editor,"value":_vm.value,"config":_vm.editorConfig},on:{"input":_vm.handleInput}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }